import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import * as echarts from "echarts";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, ref, onUnmounted } from "vue";
import { useStore } from "vuex";
import staticData from "@/assets/data/dataScreen.json";
export default defineComponent({
  name: "ExamOline",
  components: {},
  setup: function setup() {
    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var myChartRef = ref();
    var myChart;
    var total = ref(0);
    var store = useStore();
    var Data = reactive({
      option: {
        backgroundColor: "#0c1d4e",
        tooltip: {
          trigger: "axis",
          backgroundColor: "#0c1d4e",
          borderWidth: 0,
          padding: [5, 10],
          textStyle: {
            color: "#4dbdff"
          }
        },
        toolbox: {
          show: false
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
          axisLabel: {
            textStyle: {
              color: "#4dbdff"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#9EA3B4",
              opacity: 0.3
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [{
          type: "value",
          min: 0,
          // max: 50,
          // interval: 5,
          splitLine: {
            show: false
          },
          axisLabel: {
            textStyle: {
              color: "#4dbdff"
            }
          },
          name: "次数",
          nameTextStyle: {
            color: "#4dbdff",
            padding: [0, 40, 0, 0]
          }
        }],
        series: [{
          type: "line",
          symbol: "none",
          smooth: true,
          itemStyle: {
            normal: {
              color: "#23CDF1",
              lineStyle: {
                color: "#23CDF1",
                width: 2
              },
              areaStyle: {
                //区域填充样式
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: "rgba(1,255,255, 0.1)"
                }, {
                  offset: 1,
                  color: "rgba(1,255,255, 0.9)"
                }])
              }
            }
          },
          toolbox: {
            show: false
          },
          data: [100, 100, 110, 50, 120, 100, 23, 54, 120, 45, 150, 150, 60]
        }]
      }
    });
    onMounted(function () {
      if (store.state.system.demonstration) {
        Data.option.series[0].data = staticData.thoughtData;
        total.value = 30;
        getMountEcherts();
      } else {
        getList();
        taskGetExam();
      }
    });

    var getList = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getExamOnlineDataScreen();

              case 2:
                _context.next = 4;
                return getMountEcherts();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getList() {
        return _ref.apply(this, arguments);
      };
    }();

    var timer;

    var taskGetExam = function taskGetExam() {
      timer = setInterval(function () {
        getList(); // clearInterval(timer);
        // taskGetExam();
      }, 10000);
    };

    onUnmounted(function () {
      clearInterval(timer);
    }); // 网上考试

    var getExamOnlineDataScreen = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getExamOnlineDataScreen"]();

              case 2:
                res = _context2.sent;

                if (res.code == 0) {
                  Data.option.series[0].data = res.data;
                  total.value = res.data[12];
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getExamOnlineDataScreen() {
        return _ref2.apply(this, arguments);
      };
    }(); //挂载eCharts


    var getMountEcherts = function getMountEcherts() {
      myChartRef.value = document.getElementById("examMain");

      if (myChartRef.value) {
        myChart = echarts.init(myChartRef.value);
        myChart.setOption(Data.option);
      }
    };

    var initexamOnline = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                myChart.resize();

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function initexamOnline() {
        return _ref3.apply(this, arguments);
      };
    }();

    window.addEventListener('resize', function () {
      myChart.resize();
    });
    return {
      initexamOnline: initexamOnline,
      Data: Data,
      myChart: myChart,
      total: total,
      getMountEcherts: getMountEcherts,
      getList: getList,
      getExamOnlineDataScreen: getExamOnlineDataScreen
    };
  }
});